import { Image } from '@cian/ui-kit';
import * as React from 'react';

import { FloorPlan } from '../../FloorPlan';
import { IMediaItemDesktopSchema } from '../FullscreenGallery';
import { ImageSlide } from '../Slide/ImageSlide';
import { MortgageSlide } from '../Slide/MortgageSlide';
import { VideoSlide } from '../Slide/VideoSlide';

export enum EMediaType {
  /** Изображение **/
  Image = 'image',
  /** Видео **/
  Video = 'video',
  /** Ипотека **/
  Mortgage = 'mortgage',
}

const slideTypes = {
  [EMediaType.Image]: ImageSlide,
  [EMediaType.Video]: VideoSlide,
  [EMediaType.Mortgage]: MortgageSlide,
};

export interface IFullscreenSlide {
  node: React.ReactNode;
  thumbnailNode: React.ReactNode;
}

export function prepareSlides(mediaData: IMediaItemDesktopSchema[]): IFullscreenSlide[] {
  return mediaData.map((media, index) => {
    const Component = slideTypes[media.mediaType];

    return {
      node: media.isFloorPlan ? (
        <FloorPlan fullUrl={media.fullUrl} polygonPath={media.polygonPath} />
      ) : (
        <Component media={media} index={index} />
      ),
      thumbnailNode: <Image src={media.thumbnailUrl} objectFit="cover" key={index} />,
    };
  });
}
